export default __webpack_public_path__ + "static/media/3-5-3.615baacf.jpg";